/**
 * Availability API transformers
 */

import type { FactoryDto, VariantDto } from './api-types'
import type { FactorySummary, VariantSummary } from '../domain/types'

/**
 * Transform factory DTO to domain model
 */
export function transformFactoryDtoToSummary(dto: FactoryDto): FactorySummary {
  return {
    id: String(dto.id),
    documentId: dto.documentId,
    code: dto.code,
    name: dto.name || '', // Strapi returns name as string
    status: dto.factoryStatus || 'active',
  }
}

/**
 * Transform variant DTO to domain model
 */
export function transformVariantDtoToSummary(dto: VariantDto): VariantSummary {
  return {
    id: String(dto.id),
    documentId: dto.documentId,
    skuCode: dto.variantCode, // Strapi uses variantCode, domain uses skuCode
    name: dto.name || '', // Strapi returns name as string
    productName: dto.sku?.name || '', // Strapi returns name as string
    productCode: dto.sku?.code || '',
    packagingType: dto.packaging || null, // Strapi uses packaging, domain uses packagingType
    isActive: dto.isActive ?? true,
  }
}
